import {useModule} from '@/hooks/useModule';

export const useCurrentUser = () => {
    const mod = useModule('User');
    return mod.currentUser.useState();
};
